import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { AuthProvider } from "./components/context/AuthContext";
import { DashboardProvider } from "./components/context/DashboardContext";
import { CategoryProvider } from "./components/context/CategoryContext";
import { SubCategoryProvider } from "./components/context/SubcategoryContext";
import { ProductsProvider } from "./components/context/ProductsContext";
import { ModelProvider } from "./components/context/ModelContext";
import { OrderProvider } from "./components/context/OrdersContext";
import { TransactionsProvider } from "./components/context/TransactionsContext";
import { CustomersProvider } from "./components/context/CustomersContext";
import { ReviewProvider } from "./components/context/ReviewContext";
import { OfferProvider } from "./components/context/OfferContext";
import { FAQProvider } from "./components/context/FAQContext";
import { CanvaProvider } from "./components/context/CanvaContext";
import { DiscountTypeProvider } from "./components/context/DiscountTypeContext";
import { BulkSMSProvider } from "./components/context/BulkSMSContext";
import { SettingsProvider } from "./components/context/SettingsContext";
import { NotificationProvider } from "./components/context/NotificationContext";
import { ShipmentProvider } from "./components/context/ShipmentContext";
import { ReportTypesProvider } from "./components/context/ReportTypesContext";
import { ColorProvider } from "./components/context/ColorContext";
import { ProductTypeProvider } from "./components/context/ProductTypeContext";
import { ProductMaterialProvider } from "./components/context/ProductMaterialContext";
import { ProductShapeProvider } from "./components/context/ProductShapeContext";
import { CountryProvider } from "./components/context/Countrycontext";
import { CustomerTypesProvider } from "./components/context/CustomerTypesContext";
import { ContactProvider } from "./components/context/ContactContext";
import { BlogProvider } from "./components/context/BlogContext";
import { RefundProvider } from "./components/context/RefundContext";
import { PaymentTypeProvider } from "./components/context/PaymentTypeContext";


import { ExpenseProvider } from "./components/context/ExpenseContext";
import { ExpenseVoucherProvider } from "./components/context/ExpenseVoucherContext";
import { SuppliersProvider } from "./components/context/SuppliersContext";
import { StatesProvider } from "./components/context/StatesContext";
import { DistrictsProvider } from "./components/context/DistrictsContext";
import { MandalsProvider } from "./components/context/MandalsContext";
import { CitiesProvider } from "./components/context/CitiesContext";
import { SupplierTypesProvider } from "./components/context/SupplierTypesContext";
import { PurchaseVoucherProvider } from "./components/context/PurchaseVoucherContext";
import { PaymentVoucherProvider } from "./components/context/PaymentVoucherContext";
import { ItemProvider } from "./components/context/ItemContext";
import { SizesProvider } from "./components/context/SizesContext";
import { BannersProvider } from "./components/context/BannersContext";
import { CustomizedBannersProvider } from "./components/context/CustomizedBannersContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>
      <DashboardProvider>
        <CategoryProvider>
          <SubCategoryProvider>
            <ProductsProvider>
              <ModelProvider>
                <OrderProvider>
                  <TransactionsProvider>
                    <CustomerTypesProvider>
                    <CustomersProvider>
                      <ReviewProvider>
                        <OfferProvider>
                          <FAQProvider>
                            <CanvaProvider>
                              <ContactProvider>
                              <DiscountTypeProvider>
                                <BulkSMSProvider>
                                  <SettingsProvider>
                                    <NotificationProvider>
                                      <ShipmentProvider>
                                        <ReportTypesProvider>
                                          <ColorProvider>
                                            <ProductTypeProvider>
                                              <ProductMaterialProvider>
                                                <ProductShapeProvider>
                                                  <CountryProvider>
                                                    <BlogProvider>
                                                      <RefundProvider>
                                                        <PaymentTypeProvider>
                                                          <ExpenseProvider>
                                                            <ExpenseVoucherProvider>
                                                              <SuppliersProvider>
                                                                <StatesProvider>
                                                                  <DistrictsProvider>
                                                                    <MandalsProvider>
                                                                      <CitiesProvider>
                                                                        <SupplierTypesProvider>
                                                                          <PurchaseVoucherProvider>
                                                                            <PaymentVoucherProvider>
                                                                              <ItemProvider>
                                                                                <SizesProvider>
                                                                                  <BannersProvider>
                                                                                    <CustomizedBannersProvider>
                                                                                    
                                                                            <App />
                                                                            </CustomizedBannersProvider>
                                                                            </BannersProvider>
                                                                            </SizesProvider>
                                                                              </ItemProvider>
                                                                            </PaymentVoucherProvider>
                                                                          </PurchaseVoucherProvider>
                                                                        </SupplierTypesProvider>
                                                                      </CitiesProvider>
                                                                    </MandalsProvider>
                                                                  </DistrictsProvider>
                                                                </StatesProvider>
                                                              </SuppliersProvider>
                                                            </ExpenseVoucherProvider>
                                                          </ExpenseProvider>
                                                    </PaymentTypeProvider>
                                                    </RefundProvider>
                                                    </BlogProvider>
                                                  </CountryProvider>
                                                </ProductShapeProvider>
                                              </ProductMaterialProvider>
                                            </ProductTypeProvider>
                                          </ColorProvider>
                                        </ReportTypesProvider>
                                      </ShipmentProvider>
                                    </NotificationProvider>
                                  </SettingsProvider>
                                </BulkSMSProvider>
                              </DiscountTypeProvider>
                              </ContactProvider>
                            </CanvaProvider>
                          </FAQProvider>
                        </OfferProvider>
                      </ReviewProvider>
                    </CustomersProvider>
                    </CustomerTypesProvider>
                  </TransactionsProvider>
                </OrderProvider>
              </ModelProvider>
            </ProductsProvider>
          </SubCategoryProvider>
        </CategoryProvider>
      </DashboardProvider>
    </AuthProvider>
);

reportWebVitals();
